export default "__VITE_ASSET__BWVE1Z6p__"